import HeadTittle from './../../../../components/HeadTittle';
import StepperTabs from './../../../../components/StepperTabs/StepperTabs';
import {
    AddIcon,
    CompletePersonChip,
    IconChipMultiplePerson
} from '../../../../components/buttons/IconButtons';
import DeleteModal from './../../../Modals/DeleteModal';
import { VIEW_TYPE } from '../../../../enums/ViewType';
import ExtraMealApp from "../../Dining/ExtraMeal/Functionality/ExtraMealApp";
import ActiveTab from "../../Dining/ExtraMeal/SubComponents/ActiveTab";
import StepTab from "../../../../components/StepperTabs/StepTab";
import HistoryTab from "../../Dining/ExtraMeal/SubComponents/HistoryTab";
import RequestMealModal from "../../Dining/ExtraMeal/Modal/RequestMealModal";
import RequestSummary from "../../Dining/ExtraMeal/Modal/RequestSummary";
import React, {useState} from "react";
import ButtonDropdown from "../../../../components/buttons/ButtonDropdown";
import {EXTRA_MEAL_TYPE_MODEL} from "../../Dining/ExtraMeal/Model/Models";
import {TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER} from "../../DiningOrders/Model/Models";
import ExportDataBtn from "../../../../components/buttons/ExportDataBtn";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack
 * @Email : kpozos@ibl.mx
 *
 */
const ContractorSupplierFoodieMain = () => {
    const [extraMealType, setExtraMealType] = useState(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [search, setSearch] = useState(false);
    const [option, setOption] = useState(null);
    const [criteria, setCriteria] = useState();
    const [bodyForExport, setBodyForExport] = useState(null); // Data to export
    const [moduleId, setModuleId] = useState(null);

    const {
        DEV,
        permission,
        t,
        steps,
        activeStep,
        setActiveStep,
        deleteMealRequestShow,
        setDeleteMealRequestShow,
        showSummaryModal,
        setShowSummaryModal,
        userTypeId,
        itemSelected,
        setItemSelected,
        modified,
        setModified,
        qrContainerRef,
        showSupplierRequestModal,
        setShowSupplierRequestModal,
        searchElement,
        setSearchElement,
        handleStepChange,
        deleteSelectedMealRequest,
        handleShowActive,
        handleShowHistory,
        handleDownload,
        userId
    } = ExtraMealApp({
        setOption,
        setModuleId
    });

    return (
        <>
            <HeadTittle name={'foodie'}>
                { activeStep === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.ACTIVE.INDEX &&
                    <>
                        <ButtonDropdown
                            id={'btn_csf_request_meal'}
                            classes={'btn-icon-add'}
                            trans={'request_meal'}
                            spliName={false}
                            icon={AddIcon}
                            options={[
                                {
                                    id: 'mim_csf_personal',
                                    option: t('personal'),
                                    action: () => {
                                        setExtraMealType(EXTRA_MEAL_TYPE_MODEL.PERSONAL);
                                        setShowSupplierRequestModal(true);
                                    },
                                    icon: <CompletePersonChip className={"w-24px h-24px"}/>
                                },
                                {
                                    id: 'mim_csf_for_employees',
                                    option: t('for_employees'),
                                    action: () => {
                                        setExtraMealType(EXTRA_MEAL_TYPE_MODEL.FOR_EMPLOYEES);
                                        setShowSupplierRequestModal(true);
                                    },
                                    icon: <IconChipMultiplePerson className={"w-24px h-24px"}/>
                                }
                            ]}
                        />
                    </>
                }

                { activeStep === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX &&
                <>
                    {(search ? (
                        <ExportDataBtn
                            moduleId={moduleId}
                            body={criteria}
                            search={search}
                            option={option}
                            contractorSupplier={false}
                        />
                    ) : (
                        <ExportDataBtn
                            moduleId={moduleId}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            body={bodyForExport}
                            contractorSupplier={false}
                        />
                    ))
                    }
                </>
                }
            </HeadTittle>
            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.ACTIVE.INDEX} activeStep={activeStep} view={VIEW_TYPE.LIST}>
                    {activeStep === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.ACTIVE.INDEX && (
                        <>
                            <ActiveTab
                                t={t}
                                DEV={DEV}
                                permission={permission}
                                userTypeId={userTypeId}
                                modified={modified}
                                setModified={setModified}
                                setItemSelected={setItemSelected}
                                setShowSummaryModal={setShowSummaryModal}
                                setShowRequestModal={setShowSupplierRequestModal}
                                setDeleteMealRequestShow={setDeleteMealRequestShow}
                                handleDownload={handleDownload}
                                handleShowActive={handleShowActive}
                                handleShowHistory={handleShowHistory}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_FOODIE_ORDERS_CONTRACTOR_SUPPLIER.HISTORY.INDEX && (
                        <>
                            <HistoryTab
                                DEV={DEV}
                                permission={permission}
                                userTypeId={userTypeId}
                                modified={modified}
                                setModified={setModified}
                                setItemSelected={setItemSelected}
                                setShowSummaryModal={setShowSummaryModal}
                                handleDownload={handleDownload}
                                handleShowActive={handleShowActive}
                                handleShowHistory={handleShowHistory}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                activeStep={activeStep}
                                option={option}
                                setBodyForExport={setBodyForExport}
                                setSearch={setSearch}
                                simpleSearch={simpleSearch}
                                setSimpleSearch={setSimpleSearch}
                            />
                        </>
                    )}
                </StepTab>
            </StepperTabs>

            { (showSupplierRequestModal) &&
                <RequestMealModal
                    onHide={() => {
                        setItemSelected(null);
                        setExtraMealType(null);
                        setShowSupplierRequestModal(false);
                    }}
                    showRequestModal={ true }
                    itemSelected={itemSelected}
                    setModified={setModified}
                    userId={userId}
                    extraMealType={extraMealType}
                />
            }

            { (itemSelected  && showSummaryModal) &&
                <RequestSummary
                    item={itemSelected}
                    open={showSummaryModal}
                    onHide={() => {
                        setItemSelected(null);
                        setShowSummaryModal(false)
                    }}
                    activeStep={activeStep}
                    qrContainerRef={qrContainerRef}
                    handleDownloadQr={handleDownload}
                />
            }
            <DeleteModal
                show={deleteMealRequestShow}
                onHide={() => {
                    setDeleteMealRequestShow(false)
                    setItemSelected(null);
                }}
                onClickFn={() => deleteSelectedMealRequest(itemSelected.id)}
                data={[itemSelected]}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('meal_request')}
            />
        </>
    );
};

export default ContractorSupplierFoodieMain;
